var symphony = symphony || {};

;(function() {

	symphony.getURLParam = function(name) {

		if(typeof name == 'undefined') {
			return;
		}

		//http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
		name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
		var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
		var results = regex.exec(location.search);
		
		if(!_.isArrayLike(results)) {
			return;
		}

		symphony.config.zip = decodeURIComponent(results[1].replace(/\+/g, " ")) || '60192';

		if(window.localStorage && localStorage.getItem(name) !== symphony.config.zip) {
			symphony.config.updateResults = true;
			localStorage.setItem(name, symphony.config.zip);
		}

		return results === null ? "" : symphony.config.zip;

	};

	symphony.queryStringToKeyValue = function() {
		var query = window.location.search.substring(1);
		if (query != "") {
			var vars = query.split('&');
			return vars.map(function(x) { return { key: x.split('=')[0], value: x.split('=')[1] }; });
		} else {
			return [];
		}
	};

	symphony.keyValueToQueryString = function(kvPairs) {
		if (kvPairs.length > 0) {
			var vars = kvPairs.map(function(x) { return x.key + "=" + x.value });
			return "?" + vars.join("&");
		} else {
			return "";
		}
	};

})();